var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Ticket50(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "50px",
    height: "50px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#3dd9eb",
    d: "M4,9v11c2.209,0,4,1.791,4,4c0,2.209-1.791,4-4,4v11h26c1.172-1.172,1.828-1.828,3-3V12 c-1.172-1.172-1.828-1.828-3-3H4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#6c19ff",
    d: "M44,9v11c-2.209,0-4,1.791-4,4c0,2.209,1.791,4,4,4v11H33c-1.172-1.172-1.828-1.828-3-3V12 c1.172-1.172,1.828-1.828,3-3H44z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#2100c4",
    d: "M33,12c-0.586-0.586-1.043-1.043-1.5-1.5L30,12v24c0.586,0.586,1.043,1.043,1.5,1.5L33,36V12z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Ticket50);
export default __webpack_public_path__ + "static/media/icons8-ticket-50.61c72c56ee6a2397ce36f2a06821d72f.svg";
export { ForwardRef as ReactComponent };